import { createBrowserRouter } from "react-router-dom";
import Layout from "@/components/Layout";
import Index from "@/pages/Index";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Cart from "@/pages/Cart";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import UserDashboard from "@/pages/UserDashboard";
import NotFound from "@/pages/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Index />,
      },
      {
        path: "productos",
        element: <Products />,
      },
      {
        path: "producto/:id",
        element: <ProductDetail />,
      },
      {
        path: "servicios",
        element: <Services />,
      },
      {
        path: "servicio/:id",
        element: <ServiceDetail />,
      },
      {
        path: "blog",
        element: <Blog />,
      },
      {
        path: "blog/:id",
        element: <BlogPost />,
      },
      {
        path: "carrito",
        element: <Cart />,
      },
      {
        path: "admin",
        element: <Admin />,
      },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "mi-cuenta",
        element: <UserDashboard />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);